export enum AllocationType {
    FixedPrice = 'FixedPrice',
    TimeAndMaterial = 'TimeAndMaterial',
    InternalProject = 'InternalProject'
}
